<template>
    <div class="STable">
        <div v-if="queryGeneralFields.length > 0 || queryAdvancedFields.length > 0" class="query">
            <el-form :ref="queryForm" :inline="true" :model="queryForm" :label-width="labelWidth">
                <div class="fields">
                    <div class="general">
                        <el-form-item v-for="(item, index) in queryGeneralFields" :key="index" :label="item.label"
                            :prop="item.prop" class="query-from-item">
                            <el-select clearable v-if="item.type === 'select'" v-model="queryForm[item.prop]" filterable
                                :placeholder="item.placeholder">
                                <el-option v-for="(option, index1) in item.data" :key="index1" :label="option.label"
                                    :value="option.value" />
                            </el-select>

                            <el-select v-else-if="item.type === 'select2'" v-model="queryForm[item.prop]" filterable
                                clearable remote reserve-keyword :remote-method="item.remoteMethod"
                                :placeholder="item.placeholder">
                                <el-option v-for="(option, index1) in item.data" :key="index1" :label="option.label"
                                    :value="option.value" />
                            </el-select>
                            <el-select v-else-if="item.type === 'select3'" v-model="queryForm[item.prop]" filterable
                                clearable remote reserve-keyword :remote-method="item.remoteMethod"
                                :placeholder="item.placeholder">
                                <el-option v-for="(option, index1) in item.data" :key="index1" :label="option.name"
                                    :value="option.id" />
                            </el-select>
                            <el-select clearable v-else-if="item.type === 'select4'" v-model="queryForm[item.prop]"
                                multiple filterable :placeholder="item.placeholder">
                                <el-option v-for="(option, index1) in item.data" :key="index1" :label="option.label"
                                    :value="option.value" />
                            </el-select>

                            <el-switch v-else-if="item.type === 'switch'" v-model="queryForm[item.prop]"
                                :placeholder="item.placeholder" />
                            <el-date-picker v-else-if="item.type === 'date'" v-model="queryForm[item.prop]"
                                :type="item.option.type" :placeholder="item.placeholder"
                                value-format="yyyy-MM-dd HH:mm:ss" :editable="false" />
                            <el-date-picker v-else-if="item.type === 'date1'" v-model="queryForm[item.prop]" type="date"
                                :placeholder="item.placeholder" value-format="yyyy-MM-dd" />
                            <el-date-picker v-else-if="item.type === 'date2'" v-model="queryForm[item.prop]"
                                type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
                                value-format="yyyy-MM-dd HH:mm:ss" />
                            <el-date-picker v-else-if="item.type === 'date3'" v-model="queryForm[item.prop]"
                                type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                value-format="yyyy-MM-dd" />
                            <cn-region-picker v-else-if="item.type === 'pickCity'" v-model="queryForm[item.prop]"
                                :placeholder="item.placeholder" />
                            <SCity v-else-if="item.type === 'city'" v-model="queryForm[item.prop]" />

                            <el-cascader v-else-if="item.type === 'cascader'" v-model="queryForm[item.prop]"
                                :placeholder="item.placeholder" :options="item.data" :props="item.props" clearable
                                filterable />
                            <div v-else-if="item.type === 'scopeBox'" class="ScopeBox">
                                <el-input ref="scopeBoxInputStart" v-model="queryForm[item.minProp]"
                                    class="scope-box-input1" placeholder="请输入" @input="checkScopeBoxStart"><template
                                        slot="append">{{ item.unit
                                        }}</template></el-input>
                                <span class="scope-box-span">{{ item.middleLabel }}</span>
                                <el-input ref="scopeBoxInputEnd" v-model="queryForm[item.maxProp]" placeholder="请输入"
                                    class="scope-box-input2"
                                    @input="checkScopeBoxEnd(queryForm[item.maxProp])"><template slot="append">{{
                                        item.unit }}</template></el-input>
                            </div>
                            <div v-else-if="item.type === 'hide'">
                                <el-input v-show="false" v-model="queryForm[item.prop]"
                                    :placeholder="item.placeholder" />
                            </div>
                            <el-input v-else v-model="queryForm[item.prop]" :placeholder="item.placeholder" />
                        </el-form-item>
                    </div>
                    <div v-show="queryModel === 'advanced'" class="advanced">
                        <el-form-item v-for="(item, index) in queryAdvancedFields" :key="index" :label="item.label"
                            :prop="item.prop" class="query-from-item">
                            <el-select v-if="item.type === 'select'" v-model="queryForm[item.prop]" filterable clearable
                                :placeholder="item.placeholder">
                                <el-option v-for="(option, index1) in item.data" :key="index1" :label="option.label"
                                    :value="option.value">
                                    <span style="float: left">{{ option.label }}</span>
                                    <span v-show="item.select" style="float: left; margin-left: 15px">{{ option.value
                                    }}</span>
                                </el-option>
                            </el-select>
                            <el-select v-else-if="item.type === 'select2'" v-model="queryForm[item.prop]" filterable
                                clearable remote reserve-keyword :remote-method="item.remoteMethod"
                                :placeholder="item.placeholder">
                                <el-option v-for="(option, index1) in item.data" :key="index1" :label="option.label"
                                    :value="option.value" />
                            </el-select>
                            <el-select v-else-if="item.type === 'select3'" v-model="queryForm[item.prop]" filterable
                                clearable remote reserve-keyword :remote-method="item.remoteMethod"
                                :placeholder="item.placeholder">
                                <el-option v-for="(option, index1) in item.data" :key="index1" :label="option.name"
                                    :value="option.id" />
                            </el-select>
                            <el-switch v-else-if="item.type === 'switch'" v-model="queryForm[item.prop]"
                                :placeholder="item.placeholder" />
                            <el-date-picker v-else-if="item.type === 'date'" v-model="queryForm[item.prop]"
                                :type="item.option.type" :placeholder="item.placeholder"
                                value-format="yyyy-MM-dd HH:mm:ss" :editable="false" />
                            <el-date-picker v-else-if="item.type === 'date1'" v-model="queryForm[item.prop]" type="date"
                                :placeholder="item.placeholder" value-format="yyyy-MM-dd" />
                            <el-date-picker v-else-if="item.type === 'date3'" v-model="queryForm[item.prop]"
                                type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                value-format="yyyy-MM-dd" />
                            <el-date-picker v-else-if="item.type === 'date2'" v-model="queryForm[item.prop]"
                                type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
                                value-format="yyyy-MM-dd HH:mm:ss" />
                            <SCity v-else-if="item.type === 'city'" v-model="queryForm[item.prop]" />
                            <el-cascader v-else-if="item.type === 'cascader'" v-model="queryForm[item.prop]"
                                :placeholder="item.placeholder" :options="item.data" :props="item.props" clearable
                                filterable />
                            <div v-else-if="item.type === 'scopeBox'" class="ScopeBox">
                                <el-input ref="scopeBoxInputStart" v-model="queryForm[item.minProp]"
                                    class="scope-box-input1" placeholder="请输入" @input="checkScopeBoxStart">
                                    <template slot="append">{{ item.unit }}</template>
                                </el-input>
                                <span class="scope-box-span">{{ item.middleLabel }}</span>
                                <el-input ref="scopeBoxInputEnd" v-model="queryForm[item.maxProp]" placeholder="请输入"
                                    class="scope-box-input2" @input="checkScopeBoxEnd(queryForm[item.maxProp])">
                                    <template slot="append">{{ item.unit }}</template>
                                </el-input>
                            </div>
                            <el-input v-else v-model="queryForm[item.prop]" :placeholder="item.placeholder" />
                        </el-form-item>
                    </div>
                </div>
                <div class="btns">
                    <el-form-item>
                        <el-button type="primary" @click="queryTable">查询</el-button>
                        <el-button @click="resetForm()">重置</el-button>
                    </el-form-item>
                    <el-form-item v-if="queryAdvancedFields.length > 0">
                        <!-- <el-button class="model" v-if="queryAdvancedFields.length > 0" @click="switchQueryModel">{{ queryModel == "general" ? "更多" : "隐藏" }}</el-button> -->
                        <div v-if="queryModel == 'general'" class="cursor" @click="switchQueryModel">
                            <span style="color: #1890ff">展开</span><i class="iconfont el-icon-arrow-down" />
                        </div>
                        <div v-else class="cursor" @click="switchQueryModel">
                            <span style="color: #999999">收起</span><i class="iconfont el-icon-arrow-up" />
                        </div>
                    </el-form-item>
                </div>
                <div style="clear: both" />
            </el-form>
        </div>
        <div v-if="toolbar.length > 0" class="toolbar">
            <template v-for="(item, index) in toolbar">
                <template v-if="hasPermission(item.permission)">
                    <el-upload v-if="item.isUpload" :key="index" v-loading="item.option.loading" class="upload"
                        :action="item.url" :show-file-list="false" :with-credentials="true"
                        :on-success="item.option.onSuccess ? item.option.onSuccess : ''"
                        :on-error="item.option.onError ? item.option.onError : ''"
                        :on-progress="item.option.onProgress ? item.option.onProgress : ''" :before-upload="item.option.beforeUpload ? item.option.beforeUpload : ''
                            " :headers="item.option.headers">
                        <el-button :key="index" :type="item.type" plain>{{
                            item.label
                        }}</el-button>
                    </el-upload>
                    <el-button v-else-if="
                        (!item.isSelectRowShow && item.type2 != 'checkbox') ||
                        (item.isSelectRowShow &&
                            multipleSelection.length > 1 &&
                            item.type2 != 'checkbox')
                    " :key="index" :type="item.type" :icon="item.icon ? item.icon : 'el-icon-plus'" :disabled="multipleSelection.length > 1 && item.onSelect
                        ? false
                        : item.disabled
                        " @click="handleToolbar(item)">{{ item.label }}
                    </el-button>
                    <el-checkbox v-if="item.selection && item.plantSelect" :key="index" v-model="allCheck"
                        @change="allCheckEvent">{{ item.label }}
                    </el-checkbox>
                </template>
            </template>
            <template>
                <el-button v-if="isSelected && multipleSelection.length > 0" :key="index" type="danger" plain>
                    已选 {{ total }} 条
                </el-button>
            </template>
        </div>
        <div class="table">
            <el-table ref="queryTable" :data="list" border :span-method="objectSpanMethod" tooltip-effect="light"
                style="width: 100%" :row-key="getRowKey" @selection-change="handleSelectionChange"
                @select-all="selectAll" @select="selectOne" @cell-dblclick="cellClick">
                <el-table-column v-if="selection === true" type="selection" width="40" :reserve-selection="true" />
                <el-table-column v-if="isSupportRowspan" align="center" width="50" label="序号">
                    <template v-if="isSupportRowspan" slot-scope="scope">{{
                        scope.row.group + 1
                    }}</template>
                </el-table-column>
                <el-table-column v-else type="index" align="center" width="50" label="序号" />

                <el-table-column v-for="(column, index) in columns" :key="index" :fixed="column.fixed"
                    :prop="column.prop" show-overflow-tooltip :label="column.label" :width="column.width"
                    :align="column.align ? column.align : 'center'">
                    <template slot-scope="scope">
                        <el-popover trigger="hover" placement="top" width="200" v-if="column.showTip">
                            <div class="showTip" style="
                  display: flex;
                  justify-content: space-between;
                  margin: 0 5px;
                ">
                                <div class="member" style="dispaly: flex; flex-direction: column">
                                    <div class="membertitle" style="color: #333333; font-weight: 700">
                                        团成员
                                    </div>
                                    <div class="memberName" style="line-height: 30px"
                                        v-for="(item, index) in scope.row.members" :key="index">
                                        {{ item.loginName }}
                                    </div>
                                </div>
                                <div class="workship" style="dispaly: flex; flex-direction: column">
                                    <div class="worktitle" style="color: #333333; font-weight: 700">
                                        贡献
                                    </div>
                                    <div class="workMount" style="line-height: 30px"
                                        v-for="(item, index) in scope.row.members" :key="index">
                                        {{ item.amount }}
                                    </div>
                                </div>
                            </div>
                            <div slot="reference" class="name-wrapper">
                                <el-tag size="medium">{{
                                    column.template(scope.$index, scope.row)
                                }}</el-tag>
                            </div>
                        </el-popover>
                        <template v-if="!column.showTip">
                            <div v-if="column.template">
                                <div v-show="scope.row.isSupportCellEdit && column.prop == editCellProp
                                    ">
                                    <el-input v-model="scope.row[column.prop]"
                                        @blur="loseFcous(scope.$index, scope.row)" />
                                    <span class="toolover">{{ editCellUnit }}</span>
                                </div>
                                <span v-show="!(
                                    scope.row.isSupportCellEdit && column.prop == editCellProp
                                )
                                    " class="toolover" style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  " v-html="column.template(scope.$index, scope.row)">{{ column.template(scope.$index, scope.row)
                                    }}</span>
                            </div>
                            <div v-else>
                                <el-input v-if="
                                    scope.row.isSupportCellEdit && column.prop == editCellProp
                                " v-model="scope.row[column.prop]" @blur="loseFcous(scope.$index, scope.row)" />
                                <div v-else>
                                    <el-switch v-if="column.label == 'disable'" v-model="scope.row.disable"
                                        active-color="#13ce66" inactive-color="#ff4949" />
                                    <el-switch v-if="column.type == 'switch'" v-model="scope.row[column.prop]"
                                        :active-value="column.activeValue" :inactive-value="column.inactiveValue"
                                        :disabled="column.disabled ? column.disabled : true" />
                                    <span v-else-if="column.click" class="toolover"
                                        style="color: #409eff; cursor: pointer" @click="tableRowClik(scope.row)">{{
                                            scope.row[column.prop] }}</span>
                                    <span v-else class="toolover">{{
                                        scope.row[column.prop]
                                    }}</span>
                                </div>
                            </div>
                        </template>
                    </template>
                </el-table-column>

                <el-table-column v-if="handless && handless.btns" fixed="right" :label="cnames" align="center"
                    :width="handless.width">
                    <template slot-scope="scope">
                        <template v-for="(btn, index) in handless.btns">
                            <template>
                                <el-popover :key="index" placement="right" width="240" trigger="click"
                                    @show="getDetail(scope.row.id)">
                                    <el-form v-if="isPlant" :model="form" label-width="80px">
                                        <el-form-item label="状态">
                                            <div style="margin-left: 80px">数量</div>
                                        </el-form-item>
                                        <el-form-item label="总数">
                                            <div style="margin-left: 80px">{{ form.total }}</div>
                                        </el-form-item>
                                        <el-form-item label="空闲">
                                            <div style="margin-left: 80px">{{ form.free }}</div>
                                        </el-form-item>
                                        <el-form-item label="充电中">
                                            <div style="margin-left: 80px">{{ form.charging }}</div>
                                        </el-form-item>
                                        <el-form-item label="占用">
                                            <div style="margin-left: 80px">{{ form.takeUp }}</div>
                                        </el-form-item>
                                        <el-form-item label="离线">
                                            <div style="margin-left: 80px">{{ form.offLine }}</div>
                                        </el-form-item>
                                        <el-form-item label="故障">
                                            <div style="margin-left: 80px">{{ form.broken }}</div>
                                        </el-form-item>
                                    </el-form>
                                    <el-button slot="reference">查看</el-button>
                                </el-popover>
                            </template>
                        </template>
                    </template>
                </el-table-column>

                <el-table-column v-if="handles2 && handles2.btns" fixed="right" :label="handles2.label" align="center"
                    :width="handles2.width">
                    <template slot-scope="scope">
                        <template v-for="(btn, index) in handles2.btns">
                            <el-switch :key="index" v-model="scope.row[btn.prop]" :disabled="btn.getLabelDisabled ? btn.getLabelDisabled(scope.row) : false
                                " :active-value="btn.activeValue" :inactive-value="btn.inactiveValue"
                                @change="handleTable(btn, scope.$index, scope.row)" />
                        </template>
                    </template>
                </el-table-column>

                <el-table-column v-if="handles && handles.btns" fixed="right" label="操作" align="center"
                    :width="handles.width ? handles.width : '400'">
                    <template slot-scope="scope">
                        <template v-for="(btn, index) in handles.btns">
                            <template v-if="hasPermission(btn.permission)">
                                <el-button v-show="btn.isShowFun ? btn.isShowFun(scope.row) : true" :key="index"
                                    :style="btn.style" type="text" size="small" :disabled="btn.getLabelDisabled
                                        ? btn.getLabelDisabled(scope.row)
                                        : false
                                        " @click="handleTable(btn, scope.$index, scope.row)">
                                    <span :style="btn.getLabelStyle ? btn.getLabelStyle(scope.row) : ''
                                        ">
                                        {{ btn.getLabel ? btn.getLabel(scope.row) : $t(btn.label) }}
                                    </span>
                                </el-button>
                            </template>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination v-if="total > 0 && isShowPage" background :current-page="pageNo"
                :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total,prev, pager, next, sizes, jumper"
                :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
    </div>
</template>

<script>
export default {
    name: "STable",
    components: {},
    props: {
        method: {
            type: String,
            default() {
                return "get";
            },
        },
        loading: {
            type: Boolean,
            default() {
                return true;
            },
        },
        labelWidth: {
            type: String,
            default() {
                return "100px";
            },
        },
        url: {
            type: String,
            default() {
                return "";
            },
        },
        selection: {
            type: Boolean,
            default() {
                return true;
            },
        },
        columns: {
            type: Array,
            default() {
                return [];
            },
        },
        listData: {
            type: Array,
            default() {
                return [];
            },
        },
        handle: {
            type: Object,
            default() {
                return {};
            },
        },
        handles: {
            type: Object,
            default() {
                return {};
            },
        },
        handles2: {
            type: Object,
            default() {
                return {};
            },
        },
        handless: {
            type: Object,
            default() {
                return {};
            },
        },
        query: {
            type: Array,
            default() {
                return [];
            },
        },
        toolbar: {
            type: Array,
            default() {
                return [];
            },
        },
        isShowPage: {
            type: Boolean,
            default() {
                return true;
            },
        },
        isNum: {
            type: Boolean,
            default() {
                return true;
            },
        },
        cnames: {
            type: String,
            default() {
                return "";
            },
        },
        keyprop: {
            type: String,
            default() {
                return "";
            },
        },
        editCellProp: {
            type: String,
            default() {
                return "";
            },
        },
        editCellUnit: {
            type: String,
            default() {
                return "";
            },
        },
        isSupportRowspan: {
            type: Boolean,
            default() {
                return false;
            },
        },
        isSupportRowspanHandles: {
            type: Boolean,
            default() {
                return false;
            },
        },
        isSupportCellEdit: {
            type: Boolean,
            default() {
                return false;
            },
        },
        spanColumns: {
            type: Number,
            default() {
                return 0;
            },
        },
        isPlant: {
            type: Boolean,
            default() {
                return true;
            },
        },
    },
    data() {
        return {
            queryModel: "general",
            queryGeneralFields: [],
            queryAdvancedFields: [],
            queryForm: {},
            isSelected: false,
            allCheck: false,
            spanArr: [],
            pos: 0,
            list: [],
            multipleSelection: [],
            // multipleSelectionAll: [],
            total: 0,
            pageNo: 1,
            pageSize: 10,
            getRowKeys(row) {
                return row.id;
            },

            record: {},

            selectData2: {},
            selectData: [],
            paramsData: {},

            form: {},
            // 保存的请求到的所有数据，整个data
            allData: {},
        };
    },
    computed: {},
    watch: {
        $route: {
            handler(newval, oldval) {
                if (newval) {
                    // console.log(localStorage.getItem('testRoute'),'testRoute')
                    // localStorage.setItem('queryForm',{})
                    // localStorage.setItem('pageNo',1)
                }
            },
            deep: true,
        },
        url(value, oldValue) {
            this.queryTable();
        },
        query(value) {
            if (value) {
                this.queryLoad(value);
            }
        },
        list: {
            handler(value) {
                if (this.allCheck) {
                    this.list.forEach((row) => {
                        if (row) {
                            this.$refs.queryTable.toggleRowSelection(row, true);
                        }
                        this.isSelected = true;
                    });
                }
            },
            deep: true,
        },
    },
    beforeCreate() { },
    created: function () {
        if (this.query) {
            this.queryLoad(this.query);
        }
        if (this.isSupportCellEdit) {
            this.addField("isSupportCellEdit", this.listData);
        }

        if (this.listData && this.listData.length > 0) {
            if (this.isSupportRowspan) {
                this.getSpanArr(this.listData, this.keyprop);
            }
            this.list = this.listData;
        } else {
            if (
                localStorage.getItem("queryForm") &&
                JSON.stringify(localStorage.getItem("queryForm")) != `"{}"`
            ) {
            } else {
                this.queryTable();
            }
        }
    },
    mounted() {
        // 查询表单强制加样式
        if (localStorage.getItem('queryForm')) {
            this.queryForm = JSON.parse(localStorage.getItem('queryForm'))
            this.pageNo = localStorage.getItem('pageNo')
            console.log(JSON.parse(localStorage.getItem('queryForm')), 'ttttttttttt')
        }
        this.queryStyle();
        if (
            localStorage.getItem("queryForm") &&
            JSON.stringify(localStorage.getItem("queryForm")) != `"{}"`
        ) {
            this.queryForm = JSON.parse(localStorage.getItem("queryForm"));
            if (this.$route.meta.show) {
                this.queryTable();
            }
        }
        if (this.$route.meta.show) {
            localStorage.removeItem("queryForm");
            localStorage.removeItem("pageNo");
        }
    },
    methods: {
        queryLoad(value) {
            value.forEach((item, i) => {
                // 设置默认日期
                if (item.haveDefaultDate && item.option.type === "date") {
                    const currentDate = this.getNowFormatDate();
                    this.$set(this.queryForm, item.prop, currentDate);
                }
                if (item.haveDefaultDate && item.option.type === "date2" && item.option.defaultDate) {
                    this.$set(this.queryForm, item.prop, item.option.defaultDate);
                }
                // 接收日期传参
                if (item.haveValue && item.data) {
                    this.$set(this.queryForm, item.prop, item.data);
                }
                // 设置默认选中项
                if (item.type === "select") {
                    this.$set(this.queryForm, item.prop, item.defaultValue);
                }

                // 从列表页面传参
                if (item.type === "hide") {
                    this.$set(this.queryForm, item.prop, item.data);
                }
            });
            this.queryGeneralFields = [];
            this.queryAdvancedFields = [];
            const fields = value;
            const totalLen = fields.length;
            let generalLen = 3;
            const advancedLen = totalLen;
            if (totalLen < 3) {
                generalLen = totalLen;
            }
            for (let i = 0; i < generalLen; i++) {
                this.queryGeneralFields.push(fields[i]);
            }
            if (generalLen < totalLen) {
                for (let i = generalLen; i < advancedLen; i++) {
                    this.queryAdvancedFields.push(fields[i]);
                }
            }
        },
        queryStyle() {
            const elFormDom = document.querySelectorAll(
                ".query-from-item .el-form-item__content"
            );
            if (elFormDom && elFormDom.length > 0) {
                for (let i = 0; i < elFormDom.length; i++) {
                    const sibling = elFormDom[i].previousElementSibling;
                    let labelwidth = "100px";
                    if (sibling.currentStyle) {
                        labelwidth = sibling.currentStyle["width"] || "100px"; // ie
                    } else {
                        labelwidth = getComputedStyle(sibling)["width"] || "100px"; // 非ie
                    }
                    elFormDom[i].style.width = `calc(100% - ${labelwidth})`;
                }
            }
        },
        getDetail(val) {
            const data = {
                id: val,
            };
            this.$store.dispatch("form/handle", {
                url: "/station/getGunStatus",
                data: data,
                method: "get",
                callback: (resp) => {
                    this.form = resp;
                },
            });
        },
        getRowKey(row) {
            return row.id;
        },
        getNowFormatDate() {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = year + "-" + month + "-" + strDate;
            return currentdate;
        },
        addField(_field, forArray) {
            forArray.forEach((item, i) => {
                item[_field] = false;
            });
        },
        allCheckEvent() {
            if (this.allCheck) {
                this.list.forEach((row) => {
                    this.$refs.queryTable.toggleRowSelection(row, true);
                });
                this.isSelected = true;
                // console.log(111, this.isSelected);
            } else {
                this.isSelected = false;
                // console.log(222, this.isSelected);
                // this.$refs.queryTable.clearSelection();
            }
        },
        // 选所有取消，当前选中的数据应是：已翻页的两页数据-取消的那一行数据
        selectOne() {
            if (this.allCheck) {
                this.allCheck = false;
            }
        },
        // 查询表单
        resetForm() {
            this.queryForm = {};
            this.queryTable();
        },
        switchQueryModel() {
            const queryModel = this.queryModel;
            if (queryModel === "general") {
                this.queryModel = "advanced";
            } else {
                this.queryModel = "general";
            }
        },

        // 操作栏
        handleToolbar(option) {
            const { isConfirm, confirmText, before } = option;
            const multipleSelection = this.multipleSelection;
            let data = {};
            if (before) data = before(multipleSelection);
            if (data === false) {
                return false;
            }
            if (isConfirm) {
                this.$confirm(
                    confirmText || "此操作将永久删除该数据, 是否继续?",
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        closeOnClickModal: false,
                        type: "warning",
                    }
                ).then(() => {
                    this.handleToolbarExecute(option, data);
                    // this.$refs.queryTable.clearSelection();
                });
            } else {
                this.handleToolbarExecute(option, data);
            }
        },
        handleToolbarExecute(option, data) {
            const o = this;
            const { url, method, handle } = option;
            const multipleSelection = this.multipleSelection;
            if (url) {
                this.$store.dispatch("table/handle", {
                    url: url,
                    data: data,
                    method: method,
                    callback: function (resp) {
                        handle(resp, o);
                    },
                });
                // this.$refs.queryTable.clearSelection();
            } else {
                if (handle) handle(multipleSelection, o);
            }
        },

        // 表格
        queryTable() {
            this.pageNo = 1;
            this.pageSize = 10;
            if (
                localStorage.getItem("pageNo") &&
                localStorage.getItem("pageNo") >= 1
            ) {
                this.pageNo = localStorage.getItem("pageNo");
            }
            const { url } = this;
            this.list = [];
            const queryData = this.queryForm;
            // console.log(this.queryForm,'queryForm')
            // console.log(JSON.stringify(queryData));
            const params = {};
            for (const key in queryData) {
                let val = queryData[key];
                if (val instanceof Array) {
                    val = val.join(",");
                }
                params[key] = val;
            }
            // console.log(params,'params')
            this.selectData = [];
            this.selectData2 = {};
            if (params.value) {
                this.selectData = params.value;
            }
            if (params) {
                this.selectData2.areaCode = params.areaCode;
                this.selectData2.operatorCode = params.operatorCode;
                this.selectData2.stationName = params.stationName;
            }
            this.paramsData = params;
            if (
                params.startTime &&
                (this.$route.path === "/systemManagement/stationBrand" ||
                    this.$route.path === "/systemManagement/stationModel")
            ) {
                if (params.startTime) {
                    let tempArr = params.startTime.split(",");
                    params.startTime = tempArr[0];
                    params.endTime = tempArr[1];
                }
            }
            this.$store.dispatch("table/page", {
                url: url,
                method: this.method,
                callback: (data) => {
                    if (data != null) {
                        this.total = data.count;
                        this.pageNo = data.pageNo;
                        this.pageSize = data.pageSize;
                        if (this.isSupportCellEdit) {
                            this.addField("isSupportCellEdit", data.list);
                        }
                        if (this.isSupportRowspan) {
                            this.getSpanArr(data.list, this.keyprop);
                        }
                        this.allData = data;
                        this.list = data.list;
                    }
                },
                data: {
                    pageNo: this.pageNo,
                    pageSize: this.pageSize,
                    loading: this.loading,
                    ...params,
                },
            });
        },
        getQueryData() {
            const queryData = this.queryForm;
            const params = {};
            for (const key in queryData) {
                let val = queryData[key];
                if (val instanceof Array) {
                    val = val.join(",");
                }
                params[key] = val;
            }
            // return this.queryForm;
            return params;
        },
        setQueryData(data) {
            this.queryForm = data;
        },
        setListData(data) {
            this.list = data;
        },
        // 取消表格全选
        selectClear() {
            this.$refs.queryTable.clearSelection();
        },
        // table表格中全选按钮
        selectAll() {
            // this.isSelected = false;
            this.allCheck = false;
        },
        handleSelectionChange(val) {
            this.isSelected = false;
            this.multipleSelection = val;
            // this.multipleSelection = this.reduceSame(val);
        },
        // reduceSame(arr) {
        //   let obj = {};
        //   return arr.reduce(function(prev, item) {
        //     obj[item.id] ? "" : (obj[item.id] = 1 && prev.push(item));
        //     return prev;
        //   }, []);
        // },
        handleCurrentChange(val) {
            this.pageNo = val;
            this.queryTable2();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.queryTable2();
        },
        queryTable2() {
            const { url } = this;
            this.list = [];
            const queryData = this.queryForm;
            const params = {};
            for (const key in queryData) {
                let val = queryData[key];
                if (val instanceof Array) {
                    val = val.join(",");
                }
                params[key] = val;
            }

            this.selectData = [];
            this.selectData2 = {};
            if (params.value) {
                this.selectData = params.value;
            }
            if (params) {
                this.selectData2.areaCode = params.areaCode;
                this.selectData2.operatorCode = params.operatorCode;
                this.selectData2.stationName = params.stationName;
            }
            // console.log(222, this.selectData);
            // console.log(333, this.selectData2);
            this.$store.dispatch("table/page", {
                url: url,
                method: this.method,
                callback: (data) => {
                    this.total = data.count;
                    this.pageNo = data.pageNo;
                    this.pageSize = data.pageSize;
                    if (this.isSupportCellEdit) {
                        this.addField("isSupportCellEdit", data.list);
                    }
                    if (this.isSupportRowspan) {
                        this.getSpanArr(data.list, this.keyprop);
                    }
                    this.list = data.list;
                },
                data: {
                    pageNo: this.pageNo,
                    pageSize: this.pageSize,
                    ...this.paramsData,
                },
            });
        },
        handleTable(option, index, record) {
            if (option.label === "详情" || "修改") {
                localStorage.setItem("testRoute", 1);
                localStorage.setItem("pageNo", this.pageNo);
                localStorage.setItem("queryForm", JSON.stringify(this.queryForm));
            }
            this.record = record;
            const { isConfirm, confirmText, before } = option;
            let data = {};
            if (before) data = before(index, record);
            if (data === false) {
                return false;
            }
            if (isConfirm) {
                this.$confirm(
                    confirmText || "此操作将永久删除该数据, 是否继续?",
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        closeOnClickModal: false,
                        type: "warning",
                    }
                ).then(() => {
                    this.handleTableExecute(option, record, data);
                });
            } else {
                this.handleTableExecute(option, record, data);
            }
        },
        handleTableExecute(option, record, data) {
            const o = this;
            const { url, method, handle } = option;
            if (url) {
                this.$store.dispatch("table/handle", {
                    url: url,
                    data: data,
                    method: method,
                    callback: function (resp) {
                        handle(resp, o);
                    },
                });
            } else {
                if (handle) handle(record, o);
            }
        },
        getRecord() {
            return this.record;
        },
        getTotal() {
            return this.total;
        },

        hasPermission(permission) {
            if (!permission) {
                return true;
            }
            let flag = false;
            const menus = this.$store.state.login.menu;
            for (let i = 0; i < menus.length; i++) {
                const menu = menus[i];
                if (menu === permission) {
                    flag = true;
                    break;
                }
            }
            return flag;
        },

        getSpanArr(data, keyprop) {
            this.spanArr = [];
            for (var i = 0; i < data.length; i++) {
                if (i === 0) {
                    this.spanArr.push(1);
                    this.pos = 0;
                    data[i].group = i;
                } else {
                    // 判断当前元素与上一个元素是否相同
                    if (data[i][keyprop] === data[i - 1][keyprop]) {
                        this.spanArr[this.pos] += 1;
                        this.spanArr.push(0);
                        data[i].group = data[i - 1].group;
                    } else {
                        this.spanArr.push(1);
                        this.pos = i;
                        data[i].group = data[i - 1].group + 1;
                    }
                }
            }
        },
        // 合并单元格
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (!this.isSupportRowspan) {
                return;
            }
            if (
                columnIndex < this.spanColumns ||
                (this.isSupportRowspanHandles && column.label === "操作")
            ) {
                const _row = this.spanArr.length > 0 ? this.spanArr[rowIndex] : 0;
                const _col = _row > 0 ? 1 : 0;
                return {
                    // [0,0] 表示这一行不显示， [2,1]表示行的合并数
                    rowspan: _row,
                    colspan: _col,
                };
            }
        },
        tableRowClik(row) {
            this.$emit("tableRowClik", row);
        },
        cellClick(row, column) {
            if (!this.isSupportCellEdit) {
                return;
            }
            if (row.isSupportCellEdit && column.property !== this.editCellProp) {
                this.$set(row, "isSupportCellEdit", false);
            } else if (
                !row.isSupportCellEdit &&
                column.property === this.editCellProp
            ) {
                this.$set(row, "isSupportCellEdit", true);
            }
        },
        loseFcous(index, row) {
            this.$set(row, "isSupportCellEdit", false);
        },
        checkScopeBoxEnd(_value) {
            _value = _value.replace(/^(0+)|[^\d]+/g, "");
            const start = this.$refs.scopeBoxInputStart[0].value;
            const tmpStart = parseFloat(start);
            const tmpValue = parseFloat(_value);
            if (tmpValue < tmpStart) {
                _value = tmpStart + 1;
            }
            this.queryForm._prop = _value;
        },
        checkScopeBoxStart(_value) {
            _value = _value.replace(/[^0-9.]/g, "");
            const end = this.$refs.scopeBoxInputEnd[0].value;
            const tmpEnd = parseFloat(end);
            const tmpValue = parseFloat(_value);
            if (tmpValue > tmpEnd) {
                _value = tmpEnd - 1;
            }
            return _value;
        },
    },
};
</script>

<style scoped lang="less">
@import "./index.less";

.cursor {
    cursor: pointer;
}

/deep/ .el-table__fixed {
    height: 100% !important;
}

/deep/ .el-table__fixed-right {
    height: 100% !important;
}

/deep/.el-table__row .el-button--text:not(:last-child) {
    border-right: 1px solid rgba(224, 230, 237, 0.5) !important;
}

/deep/.el-pagination {
    float: right;
    padding: 20px 0;
}

.STable /deep/.table .el-table th.is-leaf {
    border-bottom: 1px solid #ebeef5;
    background-color: #f5f7fa;
    color: #606266;
}

/deep/.el-table-column--selection .cell {
    padding-left: 11px;
}

/deep/.el-table .cell.el-tooltip .toolover {
    width: 100%;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/STable/index.vue